export enum ProjectItemStatus {
	OPEN = 'OPEN',
	COMPLETED = 'COMPLETED',
	CLOSED = 'CLOSED',
	PENDING_APPROVED = 'PENDING_APPROVED',
	APPROVED = 'APPROVED',
}
